import {setup} from '@eitje/form'
import {Tooltip} from 'antd'
import {t} from './i18n'
import {Icon, Layout, Text} from '~/components'

const translatorFunc = (text, opts = {}) => {
	if (_.isString(opts)) {
		opts = {defaultValue: opts}
	}
	opts = {...opts, globals: window.globals}
	return t(text, opts)
}

setup({
	translatorFunc,
	Layout,
	Text,
	Icon,
	scoped: true,
	Tooltip,
	Wrapper: 'form',
})
